import Header from '../../components/Header/Header';
import AdminAutoparks from '../../components/AdminAutoparks/AdminAutoparks';
import AdminNavigation from '../../components/AdminNavigation/AdminNavigation';
import './admin.css';
import AddAutoparkModal from '../../components/Modal/AddAutoparkModal';
import { useState } from 'react';

function AdminAutoparksPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0); // Триггер для обновления списка

  // Обработчики для модалки
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleAutoparkCreated = () => {
    // Обновляем триггер, чтобы перезагрузить список автопарков
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <>
      <Header />
      <AdminNavigation isAutoparksPage onAddClick={handleOpenModal} />
      <div className="admin__container">
        <AdminAutoparks refreshTrigger={refreshTrigger} />
      </div>
      <AddAutoparkModal isOpen={isModalOpen} onClose={handleCloseModal} onSuccess={handleAutoparkCreated} />
    </>
  );
}

export default AdminAutoparksPage;
